/**
 * onzen-cart-drawer-open.js
 *
 * Fires CartAddEvent after any successful /cart/add.js call
 * so cart-drawer-component auto-opens.
 *
 * cart-drawer-component listens for:
 *   document.addEventListener(CartAddEvent.eventName, ...)
 *
 * CartAddEvent is imported from '@theme/events' — the compiled
 * event name is typically 'cart-add'. We intercept fetch to catch
 * all cart adds (including from add-to-cart-component).
 */

(function () {
  // The event name used by CartAddEvent in @theme/events
  // Horizon / Dawn 2.x uses 'cart-add'
  var CART_ADD_EVENT = 'cart-add';

  /**
   * Dispatch the CartAddEvent that cart-drawer-component listens for.
   * @param {object} cartData - The response from /cart/add.js
   */
  function dispatchCartAddEvent(cartData) {
    // cart-drawer-component checks event.detail.resource?.item_count
    // We need to fetch /cart.js to get item_count since /cart/add.js
    // returns the added item, not the full cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var event = new CustomEvent(CART_ADD_EVENT, {
          bubbles: true,
          composed: true,
          detail: {
            resource: {
              item_count: cart.item_count,
              items: cart.items,
            },
          },
        });
        document.dispatchEvent(event);

        // Also try opening drawer directly as fallback
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer) {
          if (typeof drawer.open === 'function') {
            drawer.open();
          } else if (typeof drawer.showDialog === 'function') {
            drawer.showDialog();
          }
        }
      })
      .catch(function () {
        // If /cart.js fails, still try to open drawer directly
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      });
  }

  /**
   * Intercept window.fetch to catch all /cart/add.js calls
   * — this covers native ATC button, BUY NOW, and any app calls.
   */
  var _originalFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
    var promise = _originalFetch.apply(this, arguments);

    if (url.includes('/cart/add')) {
      promise.then(function (response) {
        if (response.ok) {
          // Clone so the original response body is not consumed
          response.clone().json().then(function (data) {
            dispatchCartAddEvent(data);
          }).catch(function () {
            dispatchCartAddEvent({});
          });
        }
      }).catch(function () {});
    }

    return promise;
  };

})();
